import { SearchParams } from './search-params.modal';

export class SearchCategory extends SearchParams<string> {
    controlType = 'category'

    constructor(options: {} = {}) {
        super(options)
    }
}